window.console || (window.console = {
	log: function(){}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function($){
	const htmlHasClass = (_class) => {
		return $('html').hasClass(_class);
	};
	const siteName = 'jmdp';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			},
			header: {
				desktop: 150,
				sp: 70
			}
		},
		localDecision() {
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() {
			let _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			let key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);
			let includeClassLen = includeClass.length;

			for (let i=0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (let i=0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done((...args) => {
					let regExp = new RegExp(key);

					if (args[1] === 'success') { // includeが1個だけの場合
						let position = $(args[0]).filter(':first').attr('class').split(' ');
						for (let j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (let i=0; i < args.length; i++) {
							let result = args[i];
							let position = $(result[0]).filter(':first').attr('class').split(' ');

							for (let j=0; j < position.length; j++) {
								if (position[j].match(regExp)) {
									position = position[j];
									break;
								}
							}
							$('.' + position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (let i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle() {
			let $switch = $('.js-toggle');

			$switch.on('click', (e) => {
				$(e.currentTarget).toggleClass(a);
				$(e.currentTarget).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll() {
			$('a[rel="scroll"]').on('click', (event) => {
				if(/#/.test(event.currentTarget.href)) {
					var speed = 1200;
					scrollToObject(event, speed);
					return false;
				}
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.currentTarget.href.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= FUNCTIONS.va.header.sp;
					} else {
						pos -= FUNCTIONS.va.header.desktop;
					}
				}

				// lazyloadとの併用のための記述
				$.when(
					$('html, body').animate({ scrollTop: pos }, _speed, 'easeOutExpo'),
				).done(() => {
					if (hash !== '#pagetop') {
						let diff = $(hash).offset().top;
						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							diff -= FUNCTIONS.va.header.sp;
						} else {
							diff -= FUNCTIONS.va.header.desktop;
						}
						if (diff !== pos) {
							$('html, body').animate({ scrollTop: diff }, 10, 'easeOutExpo');
						}
					}
				});
			}
		},
		easeScrollHash() {
			const hash = location.hash;
			const speed = 1200;
			if (hash) {
				$(window).on('load', () => {
					$('html, body').css('display', 'none');

					setTimeout(() => {
						$('html, body').css('display', 'block');

						let _hash = '#' + hash.split('#')[1];
						let pos = $(_hash).offset().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						$('html, body').stop().animate({ scrollTop: pos }, speed, 'easeOutExpo');
					}, 100);
				});
			}
		},
		tabSwitch() {
			let $tab = $('.js-tab');
			let $content = $('.js-tab-content');
			if ($('.js-tab').length) {
				let locHash = location.hash;
				if (locHash.length > 0) {
					let href = locHash.split('#')[1];

					$tab.each((idx, ele) => {
						$(ele).removeClass(a);
						let dataSwitch = $(ele).attr('data-target');

						if (dataSwitch.match(href)) {
							$(ele).addClass(a);
						}
					});

					$content.each((idx, ele) => {
						$(ele).removeClass(a).removeClass(v);
						let dataTarget = $(ele).attr('data-target');

						if (dataTarget.match(href)) {
							$(ele).addClass(a);
							setTimeout(() => {
								$(ele).addClass(v);
							}, '200');
						}
					});
				}

				$tab.on('click', (e) => {
					$(e.currentTarget).addClass(a);
					$tab.each((idx, ele) => {
						$(ele).removeClass(a);
					});
					$content.each((idx, ele) => {
						$(ele).removeClass(a).removeClass(v);
					});

					let $switch;
					if ($(e.currentTarget).attr('data-target') === 'all') {
						$switch = $content;
					} else {
						$switch = $('[data-target=' + $(e.currentTarget).attr('data-target') + ']');
					}
					$switch.addClass(a);
					setTimeout(() => {
						$switch.addClass(v);
					}, '200');
				});
			}
		},
		pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function(e){
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if(thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		modal() {
			$('.mod-modal-img').on('click', (e) => {
				let HTML = '<div class="mod-modal-overlay">';
				HTML +=
					'<div class="mod-modal-closeArea"></div>'+
					'<span class="mod-modal-closeBtn"><span></span></span>' +
					`${$(e.currentTarget).find('img').prop('outerHTML')}</div>`;
				$('body').append(HTML);
				const $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
			$('.mod-modal-youtube').on('click', (e) => {
				let HTML = '<div class="mod-modal-youtube-overlay">';
				HTML +=
					'<div class="mod-modal-youtube-closeArea"></div>'+
					'<span class="mod-modal-youtube-closeBtn"><span></span></span>' +
					`<div class="mod-modal-youtube-content"><div class="mod-youtube"><iframe width="560" height="315" src="https://www.youtube.com/embed/${$(e.currentTarget).data('id')}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div></div>`+
					'</div>';
				$('body').append(HTML);
				const $overlay = $('.mod-modal-youtube-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-youtube-closeArea, .mod-modal-youtube-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		setImgAttrWidthHeight() {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => {
						resolve(image);
					}
					image.onerror = (error) => {
						reject(error);
					}
				});
			};

			const imgs = document.getElementsByTagName('img');

			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
				.catch((error) => {
					console.log(error);
				});
			}
		},
		dropdown() {
			$('.js-dropdown .mod-dropdown-top').on('click', (e) => {
				if (!$(e.currentTarget).closest('.js-dropdown').hasClass(a)) {
					$('.js-dropdown.is-active').removeClass(a);
					$(e.currentTarget).closest('.js-dropdown').addClass(a);
				} else {
					$(e.currentTarget).closest('.js-dropdown').removeClass(a);
				}
			});

			$(document).on('click', (e) => {
				if (!$(e.target).closest('.js-dropdown').length) {
					$('.js-dropdown').each((idx, ele) => {
						if ($(ele).hasClass(a)) { $(ele).removeClass(a); }
					})
				}
			});
		},
		bottomNav() {
			const fixedOnContainer = () => {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			const fixedOffContainer = () => {
				$('.container').css({ position: 'static' });
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};

			// 少しスクロールで表示・フッターまで進んだら隠す
			let $bottomNav = $('.mod-bottomNav');
			$(window).on('scroll', (e) => {
				let $this = $(e.currentTarget);
				let $footer = $('.footer-bottom');
				let footerPos = $footer.offset().top + $footer.height();
				let thisScroll = $this.scrollTop();
				let pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > 50) {
					$bottomNav.addClass(v);
				} else {
					$bottomNav.removeClass(v);
				}
				if (footerPos <= pagetopPos) {
					$bottomNav.addClass('is-bottom');
				} else {
					$bottomNav.removeClass('is-bottom');
				}
			});

			// ナビ開閉
			$('.mod-bottomNav-head').on('click', (e) => {
				if ($(e.currentTarget).closest('.mod-bottomNav').hasClass('is-open')) {
					$(e.currentTarget).find('span').text($(e.currentTarget).closest('.mod-bottomNav').find('h2').text());
					$(e.currentTarget).closest('.mod-bottomNav').removeClass('is-open');
					fixedOffContainer();
				} else {
					$(e.currentTarget).closest('.mod-bottomNav').addClass('is-open');
					$(e.currentTarget).find('span').text('Close');
					$(e.currentTarget).closest('.mod-bottomNav').addClass('is-open');
					fixedOnContainer();
				}
			});

			// カレント表示
			$('.mod-bottomNav-body').find('a').each((idx, ele) => {
				if (FUNCTIONS.va.pathname === $(ele).attr('href')) {
					$(ele).prev('.__arrow').addClass(a);
				}
			});
		},
		setShareLinks() {
			$('.js-share-btn').each((idx, ele) => {
				let url = encodeURIComponent(document.URL);
				let title = encodeURIComponent(document.title);
				let $this = $(ele);
				let href = $this.attr('href').replace(/#link/ig, url).replace(/#text/ig, title);

				$this.attr('href', href);
			});
		},
		storySlide() {
			if ($('.mod-story').length) {
				$('.js-story-slide').slick({
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<button class="slick-prev"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></button>',
					nextArrow: '<button class="slick-next"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></button>',
					dots: false,
					infinite: true,
					draggable: false,
					touchThreshold: 20,
					responsive: [{
						breakpoint: 1024,
						settings: {
							arrows: false,
							draggable: true,
						}
					}]
				});
			}
		},
		// SP版のヘッダーのハンバーガーメニュー
		spMenu() {
			var $menu = $('.js-menuToggle');
			var $navi = $('.js-naviToggle');
			var $favor = $('.js-favorToggle');
			var $naviLinkButton = $('.js-naviLinkButtonToggle');
			var scrollTopNow = 0;

			var openMenu = function openMenu() {
				//メニューを開く
				scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
				$menu.addClass(a);
				$navi.addClass(a);
				$favor.removeClass(a);
				$naviLinkButton.removeClass(a);
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};

			var closeMenu = function closeMenu() {
				//メニューを閉じる
				$menu.removeClass(a);
				$navi.removeClass(a);
				// SP表示のドナー登録、寄付のボタンは表示位置によって表示非表示を変える
				if ($(window).scrollTop() > 0) {
					$favor.removeClass(a);
					$naviLinkButton.addClass(a);
				}else {
					$favor.addClass(a);
					$naviLinkButton.removeClass(a);
				}
				// $naviLinkButton.removeClass(a);
				$('.container').css({
					position: 'static'
				});

				if ($('body').hasClass(f)) {
					$('body').removeClass(f);

					$(window).scrollTop(scrollTopNow);
				}
			};

			$menu.on('click', function () {
				if ($menu.hasClass(a)) {
					closeMenu();
				} else {
					openMenu();
				}
			});

			$(window).resize(function () {
				var windowWidth = $(window).width();
				if (windowWidth > 1024) {
					closeMenu();
				}
			});
		},
		// PC版のヘッダーの動作
		pcHeader() {
			// PC版ヘッダーのナビの上側が消える処理
			const naviTopToggle = () => {
				if ($(window).scrollTop() > 0) {
					$('.js-naviTopToggle').removeClass(a);
					$('.js-smallMegaPosition').addClass(a);
				}else {
					$('.js-naviTopToggle').addClass(a);
					$('.js-smallMegaPosition').removeClass(a);
				}
			};

			// SP版ヘッダーのヘッダー下のボタンが消える処理
			const favorToggle = () => {
				if (!$('.js-menuToggle').hasClass(a)) {
					if ($(window).scrollTop() > 0) {
						$('.js-favorToggle').removeClass(a);
						$('.js-naviLinkButtonToggle').addClass(a);
					}else {
						$('.js-favorToggle').addClass(a);
						$('.js-naviLinkButtonToggle').removeClass(a);
					}
				}
			};

			// スクロールをトリガとする処理
			$(window).on('scroll', function () {
				naviTopToggle();
				favorToggle();
			});
		},
		scrollBar() {
			if (!FUNCTIONS.isMobile) {

				$(window).on('load', () => {
					let scrollbar_width = window.innerWidth - document.body.scrollWidth;

					$('.js-scroll').each((idx, ele) => {
						let $adjust = $(ele).find('.js-scroll-adjustment');
						let $bar = $(ele).next('.js-scrollbar');
						let $thumb = $bar.find('.js-scrollbar-thumb');

						// 固定スクロールバーのとき（オーバーレイでない）
						if (scrollbar_width > 0) {
							$(ele).addClass('is-scrollbar');
							// スクロールバーの幅が17pxでないとき
							if (scrollbar_width !== 17) {
								$(ele).css('margin-right', '-' + scrollbar_width + 'px');
							}
						}

						// スクロールバーの高さを設定
						let scrollable_height = $(ele).height(),
							adjustment_height = $adjust.outerHeight(),
							scrollbar_height = parseInt(scrollable_height * scrollable_height / adjustment_height);
						$thumb.css('height', scrollbar_height);

						// スクロールに応じて位置変更
						let scrollbar_track = scrollable_height - scrollbar_height; console.log(scrollbar_track);
						$(ele).on('scroll', (e) => {
							let offset = $(e.currentTarget).scrollTop() * scrollbar_track / (adjustment_height - scrollable_height);
							$thumb.css('transform', 'translateY(' + offset + 'px)');
						});

						let active = false, // つまみを操作しているかどうか
						scrollbar_thumb_cursor_y;  // つまみ内のクリック位置

						// つまみでスクロールさせる(PCのみ)
						$thumb.on('mousedown', (e) => {
							active = true;
							scrollbar_thumb_cursor_y = e.pageY - $(e.currentTarget).offset().top;
							e.preventDefault();
						});
						$(document).on('mouseup', () => {
							active = false;
						});
						$(document).on('mousemove', (e) => {
							if (!active) return;
							let scrollbar_thumb_y = ((e.pageY - $bar.offset().top) / scrollbar_track * scrollbar_track) - scrollbar_thumb_cursor_y;

							// つまみが上下の領域外を超えないようにする
							if (scrollbar_thumb_y < 0) {
								scrollbar_thumb_y = 0;
							} else if (scrollbar_thumb_y > scrollbar_track) {
								scrollbar_thumb_y = scrollbar_track;
							}
							// つまみの位置設定
							$thumb.css(
								'transform', 'translateY(' + scrollbar_thumb_y + 'px)',
								'-webkit-transform', 'translateY(' + scrollbar_thumb_y + 'px)'
								);
							// つまみの位置に応じてスクロールさせる
							$(ele).scrollTop(($thumb.offset().top - $bar.offset().top) / scrollbar_track * (adjustment_height - scrollable_height));
						});
						// つまみを操作中はテキスト選択できないようにする
						$(document).on('selectstart', () => {
							if (active) return false;
						});

					});
				});
			}
		},
		loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.tabSwitch();
			_this.pageTop();
			_this.modal();
			_this.setImgAttrWidthHeight();
			_this.dropdown();
			_this.bottomNav();
			_this.setShareLinks();
			_this.storySlide();
			_this.spMenu();
			_this.pcHeader();
			_this.scrollBar();
		}
	};

	$(() => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})(window.jQuery);
